/**
 * Videos de las guías: siempre EMBEBIDOS (YouTube, Vimeo, Loom), nunca subidos. La lista de
 * dominios es la misma que valida el Backend (`help_center/sanitizer.py::ALLOWED_IFRAME_HOSTS`):
 * si alguien pegó el link «para compartir» en vez del de embed, acá se traduce.
 */
const ALLOWED_HOSTS = ['youtube.com', 'youtube-nocookie.com', 'player.vimeo.com', 'loom.com'];

function hostAllowed(host) {
    return ALLOWED_HOSTS.some((allowed) => host === allowed || host.endsWith(`.${allowed}`));
}

/** URL de embed para un iframe, o null si no es de un dominio permitido. */
export function toEmbedUrl(rawUrl) {
    let url;
    try {
        url = new URL(rawUrl);
    } catch (_) {
        return null;
    }
    if (url.protocol !== 'https:' || !hostAllowed(url.hostname)) return null;

    const host = url.hostname.replace(/^www\./, '');
    if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
        const watchId = url.searchParams.get('v');
        // `/embed/<id>` y `/shorts/<id>`: el link de un Short pasaba la allowlist de host y acá
        // devolvía null, así que el modal salía sin video y nadie avisaba (review C-GUIAS-09).
        const pathMatch = url.pathname.match(/^\/(?:embed|shorts)\/([\w-]+)/);
        const id = watchId || (pathMatch && pathMatch[1]);
        return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
    }
    if (host === 'loom.com') {
        const match = url.pathname.match(/^\/(?:share|embed)\/([\w-]+)/);
        return match ? `https://www.loom.com/embed/${match[1]}` : null;
    }
    // player.vimeo.com ya es la URL de embed.
    return url.toString();
}
